import React, { Component } from 'react';
import MerchCategorySquare from './components/MerchCategorySquare';

import './SelectCategoriesStep.css';

class SelectCategoriesStep extends Component {
    constructor(props) {
        super(props);
        // Check if we already have data for this step
        let selectedCategories = [];

        if (typeof  props.collectedData.selectCategoriesStep === 'undefined') {
            // We haven't collected any data
            selectedCategories = [];
        } else {
            selectedCategories = props.collectedData.selectCategoriesStep;
        }

        this.state = {
            merchCategories: [
               {
                   label: `Men's T-Shirts`,
                   internalName: 'mens_tshirts'
               },
               {
                   label: `Women's T-Shirts`,
                   internalName: 'womens_tshirts'
               }
            ],
            selectedCategories: selectedCategories,
            errorMessage: ''
        };

        // Bind methods
        this.selectCategory = this.selectCategory.bind(this);
        this.unselectCategory = this.unselectCategory.bind(this);
        this.processDataForNextStep = this.processDataForNextStep.bind(this);
    }

    selectCategory(categoryObj) {
        this.setState({
           selectedCategories: [...this.state.selectedCategories, categoryObj]
        });
    }

    unselectCategory(categoryObj) {
        let newSelectedCategories = this.state.selectedCategories.filter(obj => {
           return obj.internalName !== categoryObj.internalName;
        });

        this.setState({
            selectedCategories: newSelectedCategories
        });

    }

    processDataForNextStep() {
        if (this.state.selectedCategories.length === 0) {
            // Show error
            this.setState({
               errorMessage: 'Please select at least 1 category.'
            });
        } else {
            // Pass the data to the parent component state
            const data = {'selectCategoriesStep': this.state.selectedCategories};
            this.props.nextStep(data);
        }
    }

    categoryIsSelected(obj, list) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].internalName === obj.internalName) {
                return true;
            }
        }
        return false;
    }

    renderCategories() {
        return this.state.merchCategories.map(category => (
            <MerchCategorySquare
                object={category}
                name={category.label}
                key={category.internalName}
                selected={this.categoryIsSelected(category, this.state.selectedCategories)}
                selectCategory={this.selectCategory}
                unselectCategory={this.unselectCategory}
            />
        ));
    }

    getSelectedCategoryCount() {
        let objectsLength = this.state.selectedCategories.length;
        let addedText = objectsLength === 1 ? ' category selected' : ' categories selected';
        return String(objectsLength) + addedText;
    }

    render() {
        return (
          <div className="select-categories-step">
              <div className="component-content">
                  <div className="container">
                      <p>Let's figure out what kind of merch you want to sell.</p>
                      <i className="sub-header">Please select all that apply</i>

                      <div className="square-categories">
                         {this.renderCategories()}
                      </div>

                      <div className="bottom-row row">
                          <div className="col-sm-9">
                              <div className="selected-objects-count-div">
                                  <p>{this.getSelectedCategoryCount()}</p>
                              </div>

                              <p className={"categories-error " + (this.state.errorMessage.length > 0 ? '' : ' hidden-error')}>
                                {this.state.errorMessage}
                              </p>
                          </div>

                          <div className="col-sm-3">
                            <button id="nextButtonSelectCategories" onClick={this.processDataForNextStep} className="circle-step-button">
                                <i className="ion ion-android-arrow-forward" />
                            </button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        );
    }
}

export default SelectCategoriesStep;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/SelectCategoriesStep/SelectCategoriesStep.js